import { createContext, useReducer } from "react";

export const FounderContext = createContext();

export const founderReducer = (state, action) => {
    switch (action.type) {
        case 'SET_FOUNDER':
            return {
                founder: action.payload
            }
        case 'CREATE_FOUNDER':
            return {
                founder: [action.payload, ...state.founder]
            }
        case 'DELETE_FOUNDER':
            return {
                founder: state.founder.filter(a => a._id !== action.payload._id)
            }
        default:
            return state
    };
};

export const FounderContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(founderReducer, {
        founder: null
    });

    return (
        <FounderContext.Provider value={{ ...state, dispatch }}>
            {children}
        </FounderContext.Provider>
    );
};